import React from "react";
import { FaHeading, FaFileAlt, FaUserAlt, FaCalendarAlt } from "react-icons/fa";

const NoticeView = ({ currentRecord }) => {
  return (
    <div className="w-full overflow-y-auto bg-white rounded-lg shadow-md">
      <table className="w-full divide-y divide-gray-200">
        <tbody>
          <tr className="hover:bg-gray-50">
            <td className="flex items-center px-6 py-4">
              <FaHeading className="mr-3 text-blue-500" />
              <span className="text-sm font-medium text-gray-900">Title</span>
            </td>
            <td className="px-6 py-4 text-sm text-gray-500">
              {currentRecord.title}
            </td>
          </tr>
          <tr className="hover:bg-gray-50">
            <td className="flex items-center px-6 py-4">
              <FaFileAlt className="mr-3 text-green-500" />
              <span className="text-sm font-medium text-gray-900">
                Description
              </span>
            </td>
            <td className="px-6 py-4 text-sm text-gray-500">
              {currentRecord.description}
            </td>
          </tr>
          <tr className="hover:bg-gray-50">
            <td className="flex items-center px-6 py-4">
              <FaUserAlt className="mr-3 text-purple-500" />
              <span className="text-sm font-medium text-gray-900">
                Recipient
              </span>
            </td>
            <td className="px-6 py-4 text-sm text-gray-500">
              {currentRecord.sent_for}
            </td>
          </tr>
          <tr className="hover:bg-gray-50">
            <td className="flex items-center px-6 py-4">
              <FaCalendarAlt className="mr-3 text-red-500" />
              <span className="text-sm font-medium text-gray-900">
                Created At
              </span>
            </td>
            <td className="px-6 py-4 text-sm text-gray-500">
              {currentRecord.createdAt}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default NoticeView;
